// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes page-transition-slide-in {
  from {
    transform: translateX(7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-reverse-slide-in {
  from {
    transform: translateX(-7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-slide-out {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7.5rem);
  }
}
@keyframes width-grow {
  from {
    transform: scaleX(0.001);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes width-shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0.001);
  }
}
@keyframes height-grow {
  from {
    transform: scaleY(0.0001);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes height-fade-and-grow {
  from {
    opacity: 0;
    transform: scaleY(0.0001);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes height-shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0.001);
  }
}
@keyframes roll-in {
  from {
    opacity: 0;
    transform: translateX(10rem) rotate(500deg);
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
@keyframes drop {
  0% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes list-fill {
  0% {
    opacity: 0;
    transform: translateX(30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes reverse-list-fill {
  0% {
    opacity: 0;
    transform: translateX(-30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
app-root .guest-number-layout-page fieldset.lf-layouts legend {
  will-change: opacity, transform;
  animation: 0.25s ease-in normal backwards 0.15s fade-in, 0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards 0.15s page-transition-slide-in;
}
app-root .guest-number-layout-page.reverse-transitions:not(.fade-in) fieldset.lf-layouts legend {
  animation: 0.4s ease-in normal backwards 0.15s fade-in, 0.2s cubic-bezier(0.23, 0.06, 0.55, 0.42) normal backwards 0.15s page-transition-reverse-slide-in;
}
app-root .guest-number-layout-page fieldset.lf-layouts {
  margin-top: 36px;
}
@media (min-width: 600px) {
  app-root .guest-number-layout-page fieldset.lf-layouts {
    margin-top: 48px;
  }
}
app-root .guest-number-layout-page fieldset.lf-layouts legend {
  font-weight: 700;
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
}
@media (min-width: 900px) {
  app-root .guest-number-layout-page fieldset.lf-layouts legend {
    font-size: 1.5rem;
    line-height: 1.25;
  }
}
app-root .guest-number-layout-page ul.lf-layouts {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}
app-root .guest-number-layout-page ul.lf-layouts li {
  will-change: transform, opacity;
  animation: 0.3s ease-in-out normal backwards list-fill;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(1) {
  animation-delay: 0.35s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(2) {
  animation-delay: 0.41s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(3) {
  animation-delay: 0.47s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(4) {
  animation-delay: 0.53s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(5) {
  animation-delay: 0.59s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(6) {
  animation-delay: 0.65s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(7) {
  animation-delay: 0.71s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(8) {
  animation-delay: 0.77s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(9) {
  animation-delay: 0.83s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(10) {
  animation-delay: 0.89s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(11) {
  animation-delay: 0.95s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(12) {
  animation-delay: 1.01s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(13) {
  animation-delay: 1.07s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(14) {
  animation-delay: 1.13s;
}
app-root .guest-number-layout-page ul.lf-layouts li:nth-of-type(15) {
  animation-delay: 1.19s;
}
app-root .guest-number-layout-page.reverse-transitions ul.lf-layouts li {
  animation-name: reverse-list-fill;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/FormSteps/GuestNumber/LF/GuestNumberAndLayoutInput.less","webpack://./src/Styles/animations.less","webpack://./src/Styles/buttonList.less","webpack://./src/Styles/secondaryFieldset.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACPE;EACE;IACE,UAAA;EDSJ;ECNE;IACE,UAAA;EDQJ;AACF;ACLE;EACE;IACE,UAAA;EDOJ;ECJE;IACE,UAAA;EDMJ;AACF;ACHE;EACE;IACE,6BAAA;EDKJ;ECFE;IACE,wBAAA;EDIJ;AACF;ACDE;EACE;IACE,8BAAA;EDGJ;ECAE;IACE,wBAAA;EDEJ;AACF;ACCE;EACE;IACE,wBAAA;EDCJ;ECEE;IACE,8BAAA;EDAJ;AACF;ACGE;EACE;IACE,wBAAA;EDDJ;ECIE;IACE,oBAAA;EDFJ;AACF;ACKE;EACE;IACE,oBAAA;EDHJ;ECME;IACE,wBAAA;EDJJ;AACF;ACOE;EACE;IACE,yBAAA;EDLJ;ECQE;IACE,oBAAA;EDNJ;AACF;ACSE;EACE;IACE,UAAA;IACA,yBAAA;EDPJ;ECUE;IACE,UAAA;IACA,oBAAA;EDRJ;AACF;ACWE;EACE;IACE,oBAAA;EDTJ;ECYE;IACE,wBAAA;EDVJ;AACF;ACaE;EACE;IACE,UAAA;IACA,2CAAA;EDXJ;ECaE;IACE,UAAA;IACA,kCAAA;EDXJ;AACF;ACcE;EACE;IACE,UAAA;IACA,2BAAA;EDZJ;ECcE;IACE,UAAA;IACA,wBAAA;EDZJ;AACF;ACeE;EACE;IACE,UAAA;IACA,2BAAA;EDbJ;ECeE;IACE,UAAA;IACA,wBAAA;EDbJ;AACF;ACgBE;EACE;IACE,UAAA;IACA,wBAAA;EDdJ;ECgBE;IACE,UAAA;IACA,4BAAA;EDdJ;AACF;ACiBE;EACE;IACE,4BAAA;EDfJ;ECkBE;IACE,wBAAA;EDhBJ;AACF;AEjHA;EACE;IACE,UAAA;IACA,0BAAA;EFmHF;EEhHA;IACE,UAAA;IACA,wBAAA;EFkHF;AACF;AE/GA;EACE;IACE,UAAA;IACA,2BAAA;EFiHF;EE9GA;IACE,UAAA;IACA,wBAAA;EFgHF;AACF;AA1JA;EGEM,+BAAA;EFyJJ,kJAAA;ADGF;AGxJK;EF0JH,yJAAA;ADCF;AAjKA;EGiBM,gBAAA;AHmJN;AGjJM;EAAA;IACE,gBAAA;EHoJN;AACF;AAzKA;EGwBQ,gBAAA;EACA,qBAAA;EACA,kBAAA;AHoJR;AGlJQ;EAAA;IACE,iBAAA;IACA,iBAAA;EHqJR;AACF;AApLA;EECM,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AFsLN;AA5LA;EESQ,+BAAA;EACA,sDAAA;AFsLR;ADzGG;EACC,sBAAA;AC2GJ;AD5GG;EACC,sBAAA;AC8GJ;AD/GG;EACC,sBAAA;ACiHJ;ADlHG;EACC,sBAAA;ACoHJ;ADrHG;EACC,sBAAA;ACuHJ;ADxHG;EACC,sBAAA;AC0HJ;AD3HG;EACC,sBAAA;AC6HJ;AD9HG;EACC,sBAAA;ACgIJ;ADjIG;EACC,sBAAA;ACmIJ;ADpIG;EACC,sBAAA;ACsIJ;ADvIG;EACC,sBAAA;ACyIJ;AD1IG;EACC,sBAAA;AC4IJ;AD7IG;EACC,sBAAA;AC+IJ;ADhJG;EACC,sBAAA;ACkJJ;ADnJG;EACC,sBAAA;ACqJJ;AE9NK;EACC,iCAAA;AFgON","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden { .visually-hidden-content(); }\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8)\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10)\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10)\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10)\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../../Styles/secondaryFieldset.less';\n@import '../../../../Styles/buttonList.less';\n@import '../../../../Styles/mediaQueries.less';\n\napp-root {\n  .secondary-fieldset-styles(guest-number-layout-page, lf-layouts);\n  .button-list-styles(guest-number-layout-page, lf-layouts, 0.35s);\n}","app-root {\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    from {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n    }\n  }\n\n  @keyframes page-transition-slide-in {\n    from {\n      transform: translateX(7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-reverse-slide-in {\n    from {\n      transform: translateX(-7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-slide-out {\n    from {\n      transform: translateX(0);\n    }\n    \n    to {\n      transform: translateX(-7.5rem);\n    }\n  }\n\n  @keyframes width-grow {\n    from {\n      transform: scaleX(0.001);\n    }\n\n    to {\n      transform: scaleX(1);\n    }\n  }\n\n  @keyframes width-shrink {\n    from {\n      transform: scaleX(1);\n    }\n\n    to {\n      transform: scaleX(0.001);\n    }\n  }\n\n  @keyframes height-grow {\n    from {\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-fade-and-grow {\n    from {\n      opacity: 0;\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-shrink {\n    from {\n      transform: scaleY(1);\n    }\n\n    to {\n      transform: scaleY(0.001);\n    }\n  }\n\n  @keyframes roll-in {\n    from {\n      opacity: 0;\n      transform: translateX(10rem) rotate(500deg);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0) rotate(0);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    from {\n      opacity: 0;\n      transform: translateX(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-out {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-5rem);\n    }\n  }\n\n  @keyframes drop {\n    0% {\n      transform: translateY(-1rem);\n    }\n  \n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n.cubic-slide-in-animation(@delay: 0s) {\n  animation:\n    0.25s ease-in normal backwards @delay fade-in,\n    0.3s cubic-bezier(.39, .67, .61, .96) normal backwards @delay page-transition-slide-in;\n}\n.cubic-reverse-slide-in-animation(@delay: 0s) {\n  animation:\n    0.4s ease-in normal backwards @delay fade-in,\n    0.2s cubic-bezier(.23, .06, .55, .42) normal backwards @delay page-transition-reverse-slide-in;\n}\n.cubic-slide-out-animation(@delay: 0s) {\n  animation:\n    0.3s ease-in @delay forwards fade-out,\n    0.3s cubic-bezier(.23, .06, .55, .42) @delay forwards page-transition-slide-out;\n}","@import './utilities.less';\n\n .button-list-styles(@page-class, @list-class, @base-delay: 0 ) {\n  .@{page-class} {\n    ul.@{list-class} {\n      display: flex;\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 16px;\n\n      li {\n        will-change: transform, opacity;\n        animation: 0.3s ease-in-out normal backwards list-fill;\n        .sequential-delay(15, 0.06s, ~'', @base-delay);\n      }\n    }\n\n    &.reverse-transitions ul.@{list-class} li {\n      animation-name: reverse-list-fill;\n    }\n  }\n}\n\n@keyframes list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n\n@keyframes reverse-list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((-30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}","@import './utilities.less';\n@import './animations.less';\n\n.secondary-fieldset-animations(@page-class, @fieldset-class) { // called by the main mixin below\n  .@{page-class} {\n    fieldset.@{fieldset-class} legend {\n      will-change: opacity, transform;\n      .cubic-slide-in-animation(0.15s);\n    }\n    \n    &.reverse-transitions:not(.fade-in) fieldset.@{fieldset-class} legend {\n      .cubic-reverse-slide-in-animation(0.15s);\n    }\n  }\n}\n\n.secondary-fieldset-styles(@page-class, @fieldset-class) {\n  .secondary-fieldset-animations(@page-class, @fieldset-class);\n\n  .@{page-class} {\n    fieldset.@{fieldset-class} {\n      margin-top: 36px;\n      \n      @media @portraitTabletUp {\n        margin-top: 48px;\n      }\n      \n      legend {\n        font-weight: 700;\n        margin-bottom: 1.5rem;\n        font-size: 1.25rem;\n        \n        @media @landscapeTabletUp {\n          font-size: 1.5rem;\n          line-height: 1.25;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
